import React, { memo, useState } from "react";
import Button from "../components/common/button/Button";
import Input from "../components/common/Input/Input";
import LockImage from "../assets/images/lock.png";

function PasswordProtected() {
  const [error, setError] = useState(null);

  const handleClick = () => setError({ message: "Invalid password" });

  return (
    <section className="h-[800px] color-white bg-top bg-no-repeat bg-cover password-protected__hero">
      <div className="w-[90%] mx-auto md:w-auto text-center pt-[280px] pb-5">
        <div>
          <img className="mx-auto mb-[20px] w-[80px] md:w-[136px]" src={LockImage} alt="" />
          <h1 className="text-40px font-bold mb-[16px]">
            <span className="text-primary">MEMBERS</span> ACCESS ONLY
          </h1>
          <p className="mb-[26px]">
            Metator Metaverse requires special entry pass code. Please verify your identity to enter
            development mode.
          </p>
          <Input
            type="password"
            placeholder="Enter Password"
            error={error}
            className="w-full sm:w-[540px] mx-auto"
          />
          <Button onClick={handleClick} className="mx-auto mt-[24px]" title="Enter MetaTor" />
        </div>
      </div>
    </section>
  );
}

export default memo(PasswordProtected);
